// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellModalRedesign-cls1_tgT","cls2":"UpsellModalRedesign-cls2_7MF UpsellModalRedesign-cls1_tgT","strong":"UpsellModalRedesign-strong_lF9"};